/** 检验手机号是否正确 */
export function isAvaiablePhoneNum(phone:string){
  return /^09\d{8}$/.test(phone)
}
// 格式化限制数字文本框输入，只能数字或者两位小数
export function inputNum(obj: any) {
  // 清除"数字"和"."以外的字符
  obj.target.value = obj.target.value.replace(/[^\d.]/g, "");
  // 验证第一个字符是数字
  obj.target.value = obj.target.value.replace(/^\./g, "");
  // 只保留第一个, 清除多余的
  obj.target.value = obj.target.value.replace(/\.{2,}/g, ".");
  obj.target.value = obj.target.value
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  // 只能输入两个小数
  obj.target.value = obj.target.value.replace(
    /^(\-)*(\d+)\.(\d\d).*$/,
    "$1$2.$3"
  );

  //如果有小数点，不能为类似 1.10的金额
  if (obj.target.value.indexOf(".") > 0 && obj.target.value.indexOf("0") > 2) {
    obj.target.value = parseFloat(obj.target.value);
  }
  //如果有小数点，不能为类似 0.00的金额
  if (
    obj.target.value.indexOf(".") > 0 &&
    obj.target.value.lastIndexOf("0") > 2
  ) {
    obj.target.value = parseFloat(obj.target.value);
  }
  //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
  if (obj.target.value.indexOf(".") <= 0 && obj.target.value != "") {
    obj.target.value = parseFloat(obj.target.value);
  }
}

/**
 * 數據格式化成小寫
 * 空格轉成-
 * .轉成-.-
 */
export function setUrlFormat(str) {
  if (!str) return;
  let val = str.toLowerCase();
  val = val.replace(/\s+/g, "-");
  val = val.replace(/\./g, "-.-");
  val = val.replace(/&amp;/g, '&');
  return val;
};

/**
 * 将文本中的所有 URL 替换为可点击的 <a> 标签
 * @param {string} text - 要处理的文本
 * @returns {string} - 处理后的文本，链接已被 <a> 标签包裹
 */
export const replaceUrlWithAnchor = (text: string) => {
  const urlRegex = /https:\/\/8891\.com\.tw\/[a-zA-Z0-9]{4,6}/g;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" style="color: #3264FF;">${url}</a>`;
  });
};